
import Box from "@mui/material/Box"
import Grid from "@mui/material/Grid"
import Paper from "@mui/material/Paper"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { v4 as uuid } from "uuid"
import { TitleField } from "./TitleField"
import { UseCaseList } from "./UseCaseList"
import {
  backgroundURL,
  landingPageTitle,
  titleFieldPlaceholder,
} from "./experiments"
import { emptyPoll, withTitle } from "./poll"

export function PollCreationController(props: {
  onPollCreated: (id: string) => unknown
}): JSX.Element {
  function createPoll(title: string) {
    const pollId = uuid()
    localStorage[pollId] = JSON.stringify(withTitle(title, emptyPoll()))
    props.onPollCreated(pollId)
  }

  return (
    <Box
      sx={{
        background: `url(${backgroundURL}) no-repeat, linear-gradient(to bottom, black, #ddd)`,
        backgroundSize: "cover, auto",
        backgroundPosition: "center, center",
        backgroundBlendMode: "multiply",
        height: "100%",
        overflow: "auto",
        p: { xs: 1, sm: 5 },
      }}
    >
      <Grid container>
        <Grid container item>
          <Grid item xs={12} sm={7}>
            <Typography
              component="h1"
              variant="h3"
              color="white"
              children={landingPageTitle}
              sx={{ marginBottom: 1 }}
            />
            <Typography component="h2" variant="h5" color="white" paragraph>
              Settle decisions with an eye for everyone's priorities.
            </Typography>
            <Typography variant="body1" color="white" sx={{ marginBottom: 2 }}>
              Druthers is a collaborative decision-making tool that allows you to settle decisions quickly and fairly with real-time results.
            </Typography>

          </Grid>
          <Grid item xs={12} sm={5}>
            <Paper sx={{ marginBottom: 2 }}>
              <Stack p={2}>
              <TitleField
                label="Poll title"
                placeholder={titleFieldPlaceholder}
                onSubmit={createPoll}
                value=""
              />
              </Stack>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={5} sx={{
              textShadow: `2px 4px 4px rgba(0,0,0,0.6)`

          }}>
            <Typography variant="body1" color="white" sx={{ marginBottom: 2 }}>
              It's simple to use: just enter your question, invite your team, and start ranking answers in real-time. Plus, Druthers is designed to be fair, so everyone's opinion is taken into account. Try Druthers today and experience faster decision-making without compromising on fairness or quality.
            </Typography>

            <Typography variant="body1" color="white" sx={{ marginBottom: 2 }}>
              Still not convinced? Here are some examples that we've used in the past; try asking your team:
            </Typography>
            <ol>
              <Typography variant="body1" color="white"><li>"What should our company's next marketing campaign focus on?"</li></Typography>
              <Typography variant="body1" color="white"><li>"Which office location would be the best for our new branch?"</li></Typography>
              <Typography variant="body1" color="white"><li>"What should be the theme for our upcoming company event?"</li></Typography>
              <Typography variant="body1" color="white"><li>"Which vendor should we choose for our upcoming project?"</li></Typography>
              <Typography variant="body1" color="white"><li>"What benefits and perks should we offer to attract top talent?"</li></Typography>
            </ol>

            <Typography variant="body1" color="white" sx={{ marginBottom: 2 }}>
              Or, among family and friends:
            </Typography>
            <ol>
              <Typography variant="body1" color="white"><li>"Where should we go on vacation this year?"</li></Typography>
              <Typography variant="body1" color="white"><li>"What should we make for dinner tonight?"</li></Typography>
              <Typography variant="body1" color="white"><li>"Which movie should we watch tonight?"</li></Typography>
              <Typography variant="body1" color="white"><li>"Which game should we play at our next family game night?"</li></Typography>
              <Typography variant="body1" color="white"><li>"What gift should we get for our friend's birthday?"</li></Typography>
            </ol>
          </Grid>
        </Grid>
        <UseCaseList />
      </Grid>
    </Box>
  )
}
